import { useOverlayEscape } from './useOverlayEscape';

/**
 * Calls `onEscape` when the Escape key is pressed and this is the topmost overlay.
 * Only active when `enabled` is true (default).
 *
 * Participates in the shared overlay stack so stacked overlays (e.g. a dropdown
 * inside a modal) close one at a time rather than all at once.
 */
export function useEscapeKey(
  onEscape: () => void,
  enabled = true,
): void {
  useOverlayEscape(enabled, onEscape);
}
